/* Установщик «Фото и видео»: объекты в window на том месте порядка скриптов, где стоял assets/bot-photo.js (BotPhoto и BotVideo — один каркас).
   В серверном режиме движок шаблона получает сервер экрана (photo-server.ts, по экземпляру на вид), а экраны photo и video встают в реестр
   движков студии; выбирает их только список экранов сборки (engine-kit/engine-default.json — пустой до коммита переключения, инвариант I4). */
import { isServerMode } from '../../platform/server-mode';
import { createPhoto } from './engine';
import { createPhotoServer, registerPhotoEngines } from './photo-server';

export function installPhoto() {
  const server = isServerMode();
  createPhoto(server ? createPhotoServer : null);
  if (server) registerPhotoEngines();
}
